import React from 'react'
import { Grid, Typography, Box } from '@material-ui/core'

import TrackedAccounts from 'components/TrackedAccounts'

export default function SetupTrackedCards({ completeStep, Footer }) {
  return (
    <React.Fragment>
      <Grid container justifyContent='center'>
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Box textAlign='center' mb={3}>
            <Typography gutterBottom variant='h4' component='h1'>Setup Tracked Cards</Typography>
            <Typography variant='body2' gutterBottom>
              First, choose any cards associated with your funding account you’d like to track roundups and tithes from.
            </Typography>
            <Typography variant='body2'>
              Then you can add additional cards below for tracking as well, be they credit or debit.
            </Typography>
          </Box>

          <div>
            <TrackedAccounts />
          </div>
        </Grid>
      </Grid>
      <Footer handleClickNext={() => completeStep('Setup Tracked Cards')} />
    </React.Fragment>
  )
}
